import { useScale } from "common/utils";
import Constants from "common/constant";
import { MainTitleTag } from "features/courses/assets";
import { CourseProgress, CourseMessageContent } from "features/courses/types";
import { Level } from "./Level";
import { LevelAnimation } from "./LevelAnimation";
import { StageLevelRects } from "./StageLevelRects";
import { StageDescriptionRects } from "./StageDescriptionRects";

export const Levels = ({
  scale,
  stage,
  display,
  progresses,
  handleLevelPress,
}: {
  scale: number;
  stage: number;
  display: CourseMessageContent;
  progresses: CourseProgress;
  handleLevelPress: (stepId: number) => void;
}) => {
  const { width } = useScale();

  const TITLE_HEIGHT = 166;
  const LEVEL_RECT_CIRCLE_RADIUS = 96;
  const LEVEL_RECT_CIRCLE_STROKE = 20;

  const LEVEL_RECT_LEFTS = StageLevelRects[stage - 1].map((r) => r.left);
  const MIN_LEFT =
    Math.min(...LEVEL_RECT_LEFTS) -
    (282 / 2 - LEVEL_RECT_CIRCLE_RADIUS - LEVEL_RECT_CIRCLE_STROKE / 2);

  const MAX_LEFT =
    Math.max(...LEVEL_RECT_LEFTS) +
    282 / 2 +
    LEVEL_RECT_CIRCLE_RADIUS +
    LEVEL_RECT_CIRCLE_STROKE / 2;

  const offsetX =
    (width - (MAX_LEFT - MIN_LEFT) * scale) / 2 - MIN_LEFT * scale + 20 * scale;

  return (
    <>
      <div
        className="flex-row-center self-center"
        style={{
          width: 1000 * scale,
          height: TITLE_HEIGHT * scale,
        }}
      >
        <div
          className="flex-row-center"
          style={{
            width: 364 * scale,
            height: TITLE_HEIGHT * scale,
          }}
        >
          <div
            style={{
              transform: `scale(${scale})`,
            }}
            className="flex-col-view w-[364px] h-[166px] z-[10]"
          >
            <MainTitleTag />
            <p className="title-text !text-[60px] text-textcolor-black !absolute top-[20%] left-[15%] rotate-[-10deg]">
              {display?.name}
            </p>
          </div>
        </div>
      </div>

      <div className="flex-col-el flex-1 flex-center w-full h-full">
        <div className="flex-col-view w-full" style={{ height: 800 * scale }}>
          {progresses.level.map((_, index) => (
            <Level
              key={index}
              stage={stage}
              offset={offsetX}
              scale={scale}
              radius={LEVEL_RECT_CIRCLE_RADIUS}
              step={index}
              display={display}
              progresses={progresses}
              handleLevelPress={handleLevelPress}
            />
          ))}
          <LevelAnimation
            offset={offsetX}
            scale={scale}
            stroke={LEVEL_RECT_CIRCLE_STROKE}
            radius={LEVEL_RECT_CIRCLE_RADIUS}
            stage={stage}
            progresses={progresses}
          />
          <div
            className="flex-row-center !absolute"
            style={{
              width: 471 * scale,
              height: 232 * scale,
              top:
                (StageDescriptionRects[stage - 1].top - TITLE_HEIGHT) * scale,
              left: offsetX + StageDescriptionRects[stage - 1].left * scale,
            }}
          >
            <div
              style={{
                transform: `scale(${scale})`,
              }}
              className="flex-col-center w-[471px] h-[232px] z-0"
            >
              <img
                alt="ステージ概要の背景"
                src={`${Constants.assetHost}/assets/images/stage_description_bg.png`}
                className="w-[471px] h-[232px] object-contain"
              />
              <div className="flex-col-center w-[346px] h-[60px] !absolute flex-wrap rotate-[-2deg]">
                <p className="text text-textcolor-black !text-left">
                  {display?.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
